
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Popover,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Checkbox,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Edit,
  Print,
  Visibility,
} from "@mui/icons-material";
import { useMediaQuery, useTheme, Collapse, Divider } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Tooltip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState, useEffect, useRef } from "react";
import { ToastContainer } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ProformaInvoiceListApi,
  ProformaInvoiceDelete,
  ApproveProformaInvoice,
} from "../../../Services/Services";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { printPerforma } from "../Sale/performaPrint";
import { Chip } from "@mui/material";

pdfMake.vfs = pdfFonts.vfs;

const ProformaInvoiceTable = () => {
  // ✅ UPDATED: Added date_range to filters
  const [filters, setFilters] = useState({
    division: "",
    pi_no: "",
    project_name: "",
    status: "Pending",
    date_range: "today", // ✅ NEW
  });

  const [searchStatus, setSearchStatus] = useState("Pending");
  const [proformas, setProformas] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [invoiceToDelete, setInvoiceToDelete] = useState(null);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [openApproveDialog, setOpenApproveDialog] = useState(false);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [piToApprove, setPIToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [showRemarkForOrderId, setShowRemarkForOrderId] = useState(null);
  const userRole = localStorage.getItem("role");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedPI, setExpandedPI] = useState(null);

  // ✅ NEW: Date Range States
  const dateInputRef = useRef(null);
  const [selectingDate, setSelectingDate] = useState(null);
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });
  // ✅ Apply / Cancel helpers
const handleApplyCustomDateRange = () => {
  if (tempCustomDateRange.from && tempCustomDateRange.to) {
    setCustomDateRange({ ...tempCustomDateRange });
    setFilters((p) => ({ ...p, date_range: "custom" }));
    setDateMenuAnchor(null);
    setShowCustomDateInputs(false);
  } else toast.warning("Please select both From and To dates");
};

const handleCancelCustomDateRange = () => {
  setTempCustomDateRange({ from: "", to: "" });
  setShowCustomDateInputs(false);
};
const handleReset = () => {
  setFilters({
    division: "",
    pi_no: "",
    project_name: "",
    status: "Pending",
    date_range: "today",
  });
  setCustomDateRange({ from: "", to: "" });
  setTempCustomDateRange({ from: "", to: "" });
  setShowCustomDateInputs(false);
};

  // ✳️ new local states
const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
const [tempCustomDateRange, setTempCustomDateRange] = useState({ from: "", to: "" });
  // ✅ NEW: Get Date Range Display Function
  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  // ✅ NEW: Format Date Display Function
  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  // ✅ NEW: Handle Reset Function
  // const handleReset = () => {
  //   setFilters({
  //     division: "",
  //     pi_no: "",
  //     project_name: "",
  //     status: "Pending",
  //     date_range: "today",
  //   });
  //   setCustomDateRange({ from: "", to: "" });
  // };

  // ✅ UPDATED: useEffect with customDateRange dependency
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      const updatedFilters = {
        ...filters,
        from_date: customDateRange.from || "",
        to_date: customDateRange.to || "",
      };
      fetchProformas(1, updatedFilters, true);
    }, 500);

    return () => clearTimeout(handler);
  }, [filters, customDateRange]);

  const fetchProformas = async (pageNum = 1, filterObj = {}, reset = false) => {
    const params = {};
    Object.keys(filterObj).forEach((key) => {
      if (filterObj[key]?.trim?.()) {
        if (key === "id") {
          params["invoice_number"] = filterObj[key].trim();
        } else {
          params[key] = filterObj[key].trim();
        }
      } else if (filterObj[key]) {
        params[key] = filterObj[key];
      }
    });

    const res = await ProformaInvoiceListApi(pageNum, params);

    if (reset || pageNum === 1) {
      setProformas(res.results);
    } else {
      setProformas((prev) => [...prev, ...res.results]);
    }

    setHasMore(res.next !== null);
    setPage(pageNum);
  };

  // ✅ UPDATED: fetchMoreData with filters
  const fetchMoreData = () => {
    if (!hasMore) return;
    const nextPage = page + 1;
    const updatedFilters = {
      ...filters,
      from_date: customDateRange.from || "",
      to_date: customDateRange.to || "",
    };
    fetchProformas(nextPage, updatedFilters);
  };

  useEffect(() => {
    const filtered = proformas.filter((inv) => {
      const selected = inv.project || {};
      const filterProject = filters.project || {};

      return (
        (selected.company_name || "")
          .toLowerCase()
          .includes((filterProject.company_name || "").toLowerCase()) &&
        (selected.client_name || "")
          .toLowerCase()
          .includes((filterProject.client_name || "").toLowerCase()) &&
        (inv.id || "")
          .toString()
          .toLowerCase()
          .includes((filters.id || "").toLowerCase()) &&
        (selected.project_name || "")
          .toLowerCase()
          .includes((filterProject.project_name || "").toLowerCase())
      );
    });

    setFilteredInvoices(filtered);
  }, [filters, proformas]);

  const handleApprove = async (invoice, status) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    const piId = invoice?.invoice_number || invoice?.invoice?.invoice_number;
    if (!piId) {
      toast.error("PI ID is undefined.");
      return;
    }

    try {
      const updated = await ApproveProformaInvoice(
        piId,
        approvedById,
        invoice.status,
        remarkInput
      );

      const updatedList = await ProformaInvoiceListApi();
      setProformas(updatedList.results);

      toast.success(
        updated.status === "Approved"
          ? "PI approved successfully!"
          : "PI unapproved successfully!"
      );
    } catch (error) {
      toast.error("Failed to toggle PI approval.");
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  function formatOnlyDate(dateTimeString) {
  if (!dateTimeString) return "N/A";

  // Take only the date part (before T)
  const datePart = dateTimeString.split("T")[0];  // "2025-12-02"

  const [year, month, day] = datePart.split("-");

  return `${day}-${month}-${year}`;
}

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);

  return (
    <>
      {/* ✅ DESKTOP VIEW - Filters */}
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flexWrap: "nowrap",
          gap: 1,
          alignItems: "center",
          mt: -3,
          pt: 0,
          mb: 1,
        }}
      >
        {/* ✅ NEW: Date Range Dropdown */}


        {/* Radio Buttons */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexShrink: 0,
            whiteSpace: "nowrap",
          }}
        >
          <input
            type="radio"
            id="pending"
            name="status"
            value="Pending"
            checked={filters.status === "Pending"}
            onChange={handleFilterChange}
            style={{
              marginLeft: "10px",
              width: "10px",
              height: "10px",
              verticalAlign: "middle",
              transform: "scale(0.9)",
            }}
          />
          <label htmlFor="pending" style={{ fontSize: "12px" }}>
            Pending
          </label>

          <input
            type="radio"
            id="approved"
            name="status"
            value="Approved"
            checked={filters.status === "Approved"}
            onChange={handleFilterChange}
            style={{
              marginLeft: "10px",
              width: "10px",
              height: "10px",
              verticalAlign: "middle",
              transform: "scale(0.9)",
            }}
          />
          <label htmlFor="approved" style={{ fontSize: "12px" }}>
            Approved
          </label>

          <input
            type="radio"
            id="rejected"
            name="status"
            value="Rejected"
            checked={filters.status === "Rejected"}
            onChange={handleFilterChange}
            style={{
              marginLeft: "10px",
              width: "10px",
              height: "10px",
              verticalAlign: "middle",
              transform: "scale(0.9)",
            }}
          />
          <label htmlFor="rejected" style={{ fontSize: "12px" }}>
            Rejected
          </label>
        </Box>

        <TextField
          label="Date Range"
          value={
            filters.date_range === "custom" &&
              customDateRange.from &&
              customDateRange.to
              ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
              : filters.date_range === "today"
                ? "Today"
                : filters.date_range === "yesterday"
                  ? "Yesterday"
                  : filters.date_range === "this_week"
                    ? "This Week"

                    : filters.date_range === "this_month"
                      ? "This Month"

                      : "Select Date Range"
          }
          onClick={(e) => setDateMenuAnchor(e.currentTarget)}
          size="small"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <IconButton size="small" edge="end">
                <ArrowDropDownIcon />
              </IconButton>
            ),
          }}
          sx={{
            cursor: "pointer",
            minWidth: 160,
            "& .MuiInputBase-input": {
              fontSize: "0.75rem",
              padding: "4px 8px",
            },
            "& .MuiInputBase-root": {
              height: 30,
              borderRadius: 0,
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.7rem",
            },
          }}
        />

        {/* Search Boxes */}
        <TextField
          label="Search by Division."
          name="division"
          value={filters.division}
          onChange={handleFilterChange}
          sx={{
            flex: 1,
            "& .MuiInputBase-root": {
              height: 30,
              borderRadius: 0,
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.65rem",
              top: "-5px",
            },
          }}
          fullWidth
        />
        <TextField
          label="Search by PI No."
          name="pi_no"
          value={filters.pi_no}
          onChange={handleFilterChange}
          sx={{
            flex: 1,
            "& .MuiInputBase-root": { height: 30, borderRadius: 0 },
            "& .MuiInputLabel-root": { fontSize: "0.65rem", top: "-5px" },
          }}
          fullWidth
        />
        <TextField
          label="Search by Project Name"
          name="project_name"
          value={filters.project_name}
          onChange={handleFilterChange}
          sx={{
            flex: 1,
            "& .MuiInputBase-root": { height: 30, borderRadius: 0 },
            "& .MuiInputLabel-root": { fontSize: "0.65rem", top: "-5px" },
          }}
          fullWidth
        />


      </Box>

      {/* ✅ MOBILE VIEW - Filters */}
      <Box
        sx={{
          display: { xs: "block", md: "none" },
          mt: -3,
          pt: 0,
          mb: 1,
        }}
      >
        {/* ✅ NEW: Date Range Dropdown - Mobile */}


        {/* Radio Buttons - Mobile */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexShrink: 0,
            whiteSpace: "nowrap",
            width: "100%",
            justifyContent: "space-between",
            px: 1,
            mb: 1.5,
            p: 1,
            bgcolor: "#f5f5f5",
            borderRadius: 1,
          }}
        >
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <label
              style={{
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <input
                type="radio"
                name="status"
                value="Pending"
                checked={filters.status === "Pending"}
                onChange={handleFilterChange}
              />
              Pending
            </label>

            <label
              style={{
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <input
                type="radio"
                name="status"
                value="Approved"
                checked={filters.status === "Approved"}
                onChange={handleFilterChange}
              />
              Approved
            </label>

            <label
              style={{
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <input
                type="radio"
                name="status"
                value="Rejected"
                checked={filters.status === "Rejected"}
                onChange={handleFilterChange}
              />
              Rejected
            </label>
          </Box>


        </Box>

        <Box sx={{ px: 1, mb: 1.5 }}>
          <TextField
            fullWidth
            label="Date Range"
            value={
              filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
                : filters.date_range === "today"
                  ? "Today"
                  : filters.date_range === "yesterday"
                    ? "Yesterday"
                    : filters.date_range === "this_week"
                      ? "This Week"

                      : filters.date_range === "this_month"
                        ? "This Month"

                        : "Select Date Range"
            }
            onClick={(e) => setDateMenuAnchor(e.currentTarget)}
            size="small"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small" edge="end">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            sx={{
              cursor: "pointer",
              "& .MuiInputBase-root": {
                height: 40,
              },
            }}
          />
        </Box>

        {/* Search Fields Grid - Mobile */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
            },
            gap: 1.5,
            px: 1,
          }}
        >
          <TextField
            label="Search by Division"
            name="division"
            value={filters.division}
            onChange={handleFilterChange}
            size="small"
            fullWidth
            sx={{
              "& .MuiInputBase-root": {
                height: 40,
              },
            }}
          />
          <TextField
            label="Search by PI No."
            name="pi_no"
            value={filters.pi_no}
            onChange={handleFilterChange}
            size="small"
            fullWidth
            sx={{
              "& .MuiInputBase-root": {
                height: 40,
              },
            }}
          />
          <TextField
            label="Search by Project Name"
            name="project_name"
            value={filters.project_name}
            onChange={handleFilterChange}
            size="small"
            fullWidth
            sx={{
              gridColumn: { xs: "1", sm: "1 / -1" },
              "& .MuiInputBase-root": {
                height: 40,
              },
            }}
          />
        </Box>
      </Box>

      {/* ✅ NEW: Hidden Date Input for Custom Range */}
      <input
        ref={dateInputRef}
        type="date"
        style={{
          position: "absolute",
          opacity: 0,
          pointerEvents: "none",
          width: "1px",
          height: "1px",
        }}
        value={
          selectingDate === "from" ? customDateRange.from : customDateRange.to
        }
        min={selectingDate === "to" ? customDateRange.from : undefined}
        onChange={(e) => {
          const selectedDate = e.target.value;

          if (selectingDate === "from") {
            setCustomDateRange((prev) => ({ ...prev, from: selectedDate }));
            setSelectingDate("to");
            setTimeout(() => {
              dateInputRef.current?.showPicker();
            }, 100);
          } else if (selectingDate === "to") {
            setCustomDateRange((prev) => ({ ...prev, to: selectedDate }));
            setFilters((prev) => ({ ...prev, date_range: "custom" }));
            setSelectingDate(null);
            setDateMenuAnchor(null);
          }
        }}
      />

      {/* ✅ NEW: Date Range Menu */}
     {/* ✅ Date Range Menu with Inline Custom Section */}
<Menu
  anchorEl={dateMenuAnchor}
  open={Boolean(dateMenuAnchor)}
  onClose={() => {
    setDateMenuAnchor(null);
    setShowCustomDateInputs(false);
    setTempCustomDateRange({ from: "", to: "" });
  }}
  PaperProps={{ sx: { width: 340, maxHeight: 480 } }}
>
  {[
    { key: "today", label: "Today" },
    { key: "yesterday", label: "Yesterday" },
    { key: "this_week", label: "This Week" },
    { key: "this_month", label: "This Month" },
  ].map((opt) => (
    <MenuItem
      key={opt.key}
      onClick={() => {
        setFilters((p) => ({ ...p, date_range: opt.key }));
        setCustomDateRange({ from: "", to: "" });
        setDateMenuAnchor(null);
        setShowCustomDateInputs(false);
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <Typography variant="body2">{opt.label}</Typography>
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
          {getDateRangeDisplay(opt.key)}
        </Typography>
      </Box>
    </MenuItem>
  ))}

  <Divider />

  {/* Custom Range Collapsible */}
  <MenuItem
    onClick={() => setShowCustomDateInputs((s) => !s)}
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
    }}
  >
    <Typography variant="body2" sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}>
      Custom Date Range
    </Typography>
    {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
  </MenuItem>

  <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
    <Box
      sx={{ px: 2, py: 2, bgcolor: "#f5f5f5", borderTop: "1px solid #e0e0e0" }}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 1, display: "block" }}
      >
        Select Date Range
      </Typography>

      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        <TextField
          label="From Date"
          type="date"
          size="small"
          value={tempCustomDateRange.from}
          onChange={(e) =>
            setTempCustomDateRange((p) => ({ ...p, from: e.target.value }))
          }
          InputLabelProps={{ shrink: true }}
          inputProps={{ max: tempCustomDateRange.to || undefined }}
          sx={{
            flex: 1,
            "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
            "& .MuiInputLabel-root": { fontSize: "0.75rem" },
          }}
        />
        <TextField
          label="To Date"
          type="date"
          size="small"
          value={tempCustomDateRange.to}
          onChange={(e) =>
            setTempCustomDateRange((p) => ({ ...p, to: e.target.value }))
          }
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: tempCustomDateRange.from || undefined }}
          sx={{
            flex: 1,
            "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
            "& .MuiInputLabel-root": { fontSize: "0.75rem" },
          }}
        />
      </Box>

      {tempCustomDateRange.from && tempCustomDateRange.to && (
        <Typography
          variant="caption"
          sx={{
            display: "block",
            mb: 1.5,
            p: 1,
            bgcolor: "#e8f5e9",
            borderRadius: 1,
            textAlign: "center",
            color: "#2e7d32",
            fontWeight: 500,
          }}
        >
          📅 {formatDateDisplay(tempCustomDateRange.from)} to 
          {formatDateDisplay(tempCustomDateRange.to)}
        </Typography>
      )}

      <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          size="small"
          onClick={handleCancelCustomDateRange}
          sx={{ fontSize: "0.7rem", textTransform: "none", borderRadius: 1 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={handleApplyCustomDateRange}
          disabled={!tempCustomDateRange.from || !tempCustomDateRange.to}
          sx={{ fontSize: "0.7rem", textTransform: "none", borderRadius: 1 }}
        >
          Apply
        </Button>
      </Box>
    </Box>
  </Collapse>
</Menu>

      {/* Table */}
      <InfiniteScroll
        dataLength={proformas.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
        endMessage={<p style={{ textAlign: "center" }}>No more records!</p>}
      >
        {/* 🔥 MOBILE VIEW - Expandable List */}
        {isMobile ? (
          <Box sx={{ bgcolor: "background.paper" }}>
            {Array.isArray(proformas) &&
              proformas.map((invoice, idx) => (
                <Box key={invoice.invoice_number}>
                  {/* Main Row - Always Visible */}
                  <Box
                    onClick={() =>
                      setExpandedPI(
                        expandedPI === invoice.invoice_number
                          ? null
                          : invoice.invoice_number
                      )
                    }
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 1.5,
                      cursor: "pointer",
                      bgcolor:
                        idx % 2 === 0
                          ? "#fafafa !important"
                          : "#ffffff !important ",
                      "&:active": {
                        bgcolor: "#e3f2fd !important",
                      },
                      borderLeft: `4px solid ${invoice.status === "Approved"
                        ? "#4caf50"
                        : invoice.status === "Rejected"
                          ? "#f44336"
                          : "#ff9800"
                        }`,
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      {/* PI Number & Status */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 0.5,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#666",
                            minWidth: 25,
                          }}
                        >
                          #{idx + 1}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "0.85rem",
                            flex: 1,
                          }}
                        >
                          {invoice.pi_no}
                        </Typography>
                      </Box>

                      {/* Debtor & Date */}
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          color: "#666",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <span style={{ fontWeight: 500 }}>
                          {invoice.project.party_details?.company_name?.substring(
                            0,
                            25
                          ) || "N/A"}
                        </span>
                        <span style={{ color: "#999" }}>•</span>
                        <span style={{ fontSize: "0.7rem" }}>
                          {formatOnlyDate(invoice.created_at)}
                        </span>
                      </Typography>
                    </Box>

                    {/* Expand Icon */}
                    <IconButton size="small" sx={{ ml: 1 }}>
                      {expandedPI === invoice.invoice_number ? (
                        <ExpandLess fontSize="small" />
                      ) : (
                        <ExpandMore fontSize="small" />
                      )}
                    </IconButton>
                  </Box>

                  {/* Expanded Details */}
                  <Collapse
                    in={expandedPI === invoice.invoice_number}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Box
                      sx={{
                        px: 1.5,
                        py: 1,
                        bgcolor: idx % 2 === 0 ? "#f8f9fa" : "#fafafa",
                        borderLeft: `4px solid ${invoice.status === "Approved"
                          ? "#4caf50"
                          : invoice.status === "Rejected"
                            ? "#f44336"
                            : "#ff9800"
                          }`,
                      }}
                    >
                      {/* Detailed Info - 2 Column Grid */}
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: 0.8,
                          mb: 1,
                        }}
                      >
                        {/* Debtor Full */}
                        <Box sx={{ gridColumn: "1 / -1" }}>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            DEBTOR
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.75rem",
                              fontWeight: 500,
                              color: "#333",
                            }}
                          >
                            {invoice.project.party_details?.company_name ||
                              "N/A"}
                          </Typography>
                        </Box>

                        {/* Division */}
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            DIVISION
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {invoice.project?.division_name || "-"}
                          </Typography>
                        </Box>

                        {/* Project */}
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            PROJECT
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {invoice.project?.project_name || "-"}
                          </Typography>
                        </Box>

                        {/* PI Amount */}
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            PI AMOUNT
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 600,
                              color: "#1976d2",
                            }}
                          >
                            ₹{" "}
                            {Number(invoice.advance_received).toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                              }
                            )}
                          </Typography>
                        </Box>

                        {/* Received Amount */}
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            RECEIVED AMT
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 600,
                              color: "#4caf50",
                            }}
                          >
                            ₹{" "}
                            {Number(invoice.receive_amt).toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                              }
                            )}
                          </Typography>
                        </Box>

                        {/* Created By */}
                        {invoice.created_by_po && (
                          <Box>
                            <Typography
                              sx={{
                                fontSize: "0.6rem",
                                color: "#999",
                                letterSpacing: "0.5px",
                              }}
                            >
                              CREATED BY
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.72rem",
                                fontWeight: 500,
                                color: "#555",
                              }}
                            >
                              {invoice.created_by_po}
                            </Typography>
                          </Box>
                        )}

                        {/* Approved By */}
                        {invoice.approved_name && (
                          <Box>
                            <Typography
                              sx={{
                                fontSize: "0.6rem",
                                color: "#999",
                                letterSpacing: "0.5px",
                              }}
                            >
                              APPROVED BY
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.72rem",
                                fontWeight: 500,
                                color: "#555",
                              }}
                            >
                              {invoice.approved_name}
                            </Typography>
                          </Box>
                        )}
                      </Box>

                      {/* Remarks */}
                      {invoice.remarks && (
                        <Box sx={{ mb: 0.8 }}>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                              mb: 0.3,
                            }}
                          >
                            REMARKS
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              color: "#555",
                              fontStyle: "italic",
                              lineHeight: 1.3,
                            }}
                          >
                            {invoice.remarks}
                          </Typography>
                        </Box>
                      )}

                      <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                      {/* Action Buttons */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        {/* Approve - Only Admin */}
                        {userRole != "Staff" && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                              bgcolor:
                                invoice.status === "Approved"
                                  ? "#e8f5e9"
                                  : invoice.status === "Rejected"
                                    ? "#ffebee"
                                    : "#fff3e0",
                              px: 1,
                              py: 0.5,
                              borderRadius: "6px",
                              border: `1px solid ${invoice.status === "Approved"
                                ? "#4caf50"
                                : invoice.status === "Rejected"
                                  ? "#f44336"
                                  : "#ff9800"
                                }`,
                            }}
                          >
                            <Checkbox
                              checked={
                                invoice.status === "Approved" ||
                                invoice.status === "Rejected"
                              }
                              onChange={(e) => {
                                e.stopPropagation();
                                setApproveAnchorEl(e.currentTarget);
                                setPIToApprove(invoice);
                              }}
                              sx={{
                                padding: 0,
                                transform: "scale(0.75)",
                                color:
                                  invoice.status === "Approved"
                                    ? "#4caf50"
                                    : invoice.status === "Rejected"
                                      ? "#f44336"
                                      : "#ff9800",
                                "&.Mui-checked": {
                                  color:
                                    invoice.status === "Approved"
                                      ? "#4caf50"
                                      : "#f44336",
                                },
                              }}
                            />
                            <Typography
                              sx={{
                                fontSize: "0.7rem",
                                fontWeight: 600,
                                color:
                                  invoice.status === "Approved"
                                    ? "#2e7d32"
                                    : invoice.status === "Rejected"
                                      ? "#c62828"
                                      : "#f57c00",
                              }}
                            >
                              {invoice.status === "Approved"
                                ? "Approved"
                                : invoice.status === "Rejected"
                                  ? "Rejected"
                                  : "Approve"}
                            </Typography>
                          </Box>
                        )}

                        {/* Action Buttons */}
                        <Box sx={{ display: "flex", gap: 0.6 }}>
                          {/* Edit */}
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(
                                `/dashboard/performaInvoice/${invoice.invoice_number}`,
                                { state: { invoice } }
                              );
                            }}
                            disabled={invoice.status === "Approved"}
                            sx={{
                              bgcolor: "#e3f2fd",
                              borderRadius: "6px",
                              width: 32,
                              height: 32,
                              "&:hover": {
                                bgcolor: "#bbdefb",
                                transform: "scale(1.05)",
                              },
                              "&:disabled": {
                                bgcolor: "#f5f5f5",
                              },
                              transition: "all 0.2s",
                            }}
                          >
                            <Edit sx={{ fontSize: "1rem", color: "#1976d2" }} />
                          </IconButton>

                          {/* Delete */}
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              setAnchorEl(e.currentTarget);
                              setInvoiceToDelete(invoice.invoice_number);
                            }}
                            disabled={invoice.status === "Approved"}
                            sx={{
                              bgcolor: "#ffebee",
                              borderRadius: "6px",
                              width: 32,
                              height: 32,
                              "&:hover": {
                                bgcolor: "#ffcdd2",
                                transform: "scale(1.05)",
                              },
                              "&:disabled": {
                                bgcolor: "#f5f5f5",
                              },
                              transition: "all 0.2s",
                            }}
                          >
                            <DeleteIcon
                              sx={{ fontSize: "1rem", color: "#d32f2f" }}
                            />
                          </IconButton>

                          {/* Print */}
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              printPerforma(invoice);
                            }}
                            sx={{
                              bgcolor: "#e8f5e9",
                              borderRadius: "6px",
                              width: 32,
                              height: 32,
                              "&:hover": {
                                bgcolor: "#c8e6c9",
                                transform: "scale(1.05)",
                              },
                              transition: "all 0.2s",
                            }}
                          >
                            <Print
                              sx={{ fontSize: "1rem", color: "#4caf50" }}
                            />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  </Collapse>

                  {/* Divider between items */}
                  <Divider />
                </Box>
              ))}
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - Table */
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: "max-content",
                "& td, & th": {
                  borderBottom: "1px solid #ccc",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TableHead
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark"
                        ? "black"
                        : "#f5f5f5 !important",
                  },
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5 !important",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333 !important",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell align="center">Approve</TableCell>
                  )}
                  <TableCell align="center">S.No.</TableCell>

                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      background: "#fff !important",
                      zIndex: 3,
                    }}
                    align="center"
                  >
                    PI No.
                  </TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Debtor</TableCell>
                  <TableCell align="center">Division</TableCell>
                  <TableCell align="center">PI Amt</TableCell>
                  <TableCell align="center">Rec Amt</TableCell>
                  <TableCell align="center">Project</TableCell>
                  <TableCell align="center">Created By</TableCell>
                  <TableCell align="center">Approved By</TableCell>
                  <TableCell align="center">Date</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#fff !important",
                      zIndex: 3,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(proformas) &&
                  proformas.map((invoice, idx) => (
                    <TableRow
                      key={invoice.invoice_number}
                      hover
                      sx={{
                        "& .MuiTableCell-root": {
                          padding: "0px !important",
                          paddingLeft: "13px !important",
                          paddingRight: "13px !important",
                          fontSize: { xs: "0.65rem", sm: "0.75rem" },
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          color: (theme) =>
                            theme.palette.mode === "dark" ? "white" : "inherit",
                          backgroundColor: (theme) =>
                            theme.palette.mode === "dark" ? "black" : "inherit",
                        },
                      }}
                    >
                      {userRole != "Staff" && (
                        <TableCell align="center">
                          <Checkbox
                            checked={
                              invoice.status === "Approved" ||
                              invoice.status === "Rejected"
                            }
                            onChange={(e) => {
                              setApproveAnchorEl(e.currentTarget);
                              setPIToApprove(invoice);
                            }}
                            sx={{
                              padding: 0,
                              paddingLeft: 1,
                              paddingRight: 1,
                              transform: "scale(0.6)",
                              color:
                                invoice.status === "Approved"
                                  ? "green"
                                  : invoice.status === "Rejected"
                                    ? "red"
                                    : "grey",
                              "&.Mui-checked": {
                                color:
                                  invoice.status === "Approved"
                                    ? "green"
                                    : "red",
                              },
                            }}
                          />
                        </TableCell>
                      )}

                      <TableCell align="center">{idx + 1}</TableCell>

                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          background: "#f9f9f9 !important",
                          zIndex: 1,
                        }}
                        align="center"
                      >
                        {invoice.pi_no}
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={
                            invoice.status === "Approved"
                              ? "Approved"
                              : invoice.status === "Rejected"
                                ? "Rejected"
                                : "Pending"
                          }
                          color={
                            invoice.status === "Approved"
                              ? "success"
                              : invoice.status === "Rejected"
                                ? "error"
                                : "warning"
                          }
                          variant="outlined"
                          size="small"
                          sx={{
                            height: "10px",
                            transform: "scale(0.8)",
                            "& .MuiChip-label": {
                              padding: "0 6px",
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip
                          title={
                            invoice.project.party_details?.company_name || "-"
                          }
                          arrow
                        >
                          <span>
                            {truncateText(
                              invoice.project.party_details?.company_name ||
                              "-",
                              20
                            )}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                        {invoice.project?.division_name || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {Number(invoice.advance_received).toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                          }
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {Number(invoice.receive_amt).toLocaleString("en-IN", {
                          minimumFractionDigits: 1,
                          maximumFractionDigits: 1,
                        })}
                      </TableCell>

                      <TableCell align="center">
                        {invoice.project?.project_name || "-"}
                      </TableCell>

                      <TableCell align="center">
                        {invoice.created_by_po || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {invoice.approved_name || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {formatOnlyDate(invoice.created_at)}
                      </TableCell>
                      <TableCell>
                        <Tooltip title={invoice.remarks} arrow>
                          <span>{truncateText(invoice.remarks, 20)}</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          right: 0,
                          backgroundColor: "#f9f9f9 !important",
                          zIndex: 1,
                        }}
                        align="center"
                      >
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          onClick={() =>
                            navigate(
                              `/dashboard/performaInvoice/${invoice.invoice_number}`,
                              {
                                state: { invoice },
                              }
                            )
                          }
                          disabled={invoice.status === "Approved"}
                          color="primary"
                        >
                          <Edit transform="scale(0.6)" />
                        </IconButton>
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          color="error"
                          onClick={(e) => {
                            setAnchorEl(e.currentTarget);
                            setInvoiceToDelete(invoice.invoice_number);
                          }}
                          disabled={invoice.status === "Approved"}
                        >
                          <DeleteIcon transform="scale(0.6)" />
                        </IconButton>
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          onClick={() => printPerforma(invoice)}
                        >
                          <Print transform="scale(0.6)" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      <ToastContainer position="top-right" autoClose={3000} />

      <Popover
        open={Boolean(approveAnchorEl)}
        anchorEl={approveAnchorEl}
        onClose={() => {
          setApproveAnchorEl(null);
          setPIToApprove(null);
          setRemarkInput("");
          setShowRemarkForOrderId(null);
          setActionType(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2, minWidth: 250 }}>
          {showRemarkForOrderId === piToApprove?.invoice_number ? (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Please enter remark before{" "}
                {actionType === "Approved" ? "approving" : "rejecting"}:
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={remarkInput}
                onChange={(e) => setRemarkInput(e.target.value)}
                placeholder="Enter remark"
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color={actionType === "Approved" ? "success" : "error"}
                  size="small"
                  onClick={() => {
                    if (!remarkInput.trim()) {
                      toast.error("Remark is required!");
                      return;
                    }
                    handleApprove({
                      ...piToApprove,
                      status: actionType,
                      remarks: remarkInput,
                    });
                    setApproveAnchorEl(null);
                    setPIToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForOrderId(null);
                    setActionType(null);
                  }}
                >
                  Yes
                </Button>
                <Button
                  size="small"
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setPIToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForOrderId(null);
                    setActionType(null);
                  }}
                >
                  No
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Do you want to approve or reject this Sales order?
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color="success"
                  size="small"
                  onClick={() => {
                    setShowRemarkForOrderId(piToApprove?.invoice_number);
                    setActionType("Approved");
                  }}
                >
                  Approve
                </Button>
                <Button
                  color="error"
                  size="small"
                  onClick={() => {
                    setShowRemarkForOrderId(piToApprove?.invoice_number);
                    setActionType("Rejected");
                  }}
                >
                  Reject
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Popover>
    </>
  );
};

export default ProformaInvoiceTable;